import angular from 'angular';
import importDocumentDialog from './importDocumentDialog';
import controller from './import-document.controller';
import directive from './import-document.directive';

const library = require('@safe-systems/ss-ui-components');

const { ssDialogService } = library;

export default angular.module('app.components.global.importDocument', [
  importDocumentDialog,
  ssDialogService,
])
  .directive('importDocument', directive)
  .controller('ImportDocumentDirectiveController', controller)
  .name;

console.log('app.components.global.importDocument created');
